import { useState, useEffect } from "react";
import { Card, Input, CardHeader, Table, Container, Row, Button, Modal} from "reactstrap";
import CustomerHeader from "../../components/Headers/CustomerHeader";
import helper from '../../services/helper.service';
import customerApi from '../../services/customer.service';
import session from '../../services/session.service';
import GoogleMapReact from 'google-map-react';
import TrackerMarker from "../../components/Markers/TrackerMarker";
import {
  formatBatteryLevel,
  getBatteryTableRowClass,
} from '../../utils/gpsTrackerBattery';

function GPSTracker() {
  const [trackers, setTrackers] = useState([]);
  const [selectedTrackerIds, setSelectedTrackerIds] = useState([]);
  const [trackerPositions, setTrackerPositions] = useState([]);
  const [showMap, setShowMap] = useState(false);
  const [centerLati, setCenterLati] = useState(session.get("clubInfo").latitude);
  const [centerLong, setCenterLong] = useState(session.get("clubInfo").longitude);
  const [isEdit, setIsEdit] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);

  const clubId = session.get('clubInfo').clubId;
  const facilityId = session.get('clubInfo').facility_id;

  useEffect(() => {
    fetchGpsTrackers();
    const interval = setInterval(fetchGpsTrackers, 60000);
    return () => { clearInterval(interval) }
  }, [clubId]);

  useEffect(() => {
    if(showMap) {
      getGPSTrackerPositions(selectedTrackerIds);
      const interval = setInterval(() => getGPSTrackerPositions(selectedTrackerIds), 60000);
      return () => { clearInterval(interval) }
    }
  }, [showMap, selectedTrackerIds]);

  const getGPSTrackerPositions = (tracker_ids) => {
    customerApi.getTrackerPositions({tracker_ids}).then((response) => {
      if (response.status === 200) {
        const result = response.data;
        const tempList = selectedTrackerIds.map(id => {
          const temp = trackers.find((t2) => t2.tracking_id === id)
          if(temp) {
            return {...result[id], ...temp};
          }
          return result[id] || {};
         });
        setTrackerPositions(tempList);
        console.log("ids ", trackers)
        console.log("result ", tempList);
      } else {
        helper.showToast("Error", "Failed to get the position of GPS Trackers", 3);
      }
    });
  }

  const fetchGpsTrackers = () => {
    // Facility wale club (multi-course) ke liye DONO courses ke trackers ek saath — bina login/out.
    const request = facilityId
      ? customerApi.getFacilityTrackers({ facility_id: facilityId })
      : customerApi.getGpsTrackers({ club_id: clubId });
    request.then((response) => {
      if (response.status === 200) {
        // Natural sort by numeric prefix in name (1-, 2-, 3-, ... 10-, 11- instead of 1-, 10-, 11-, 2-)
        const naturalSort = (a, b) => {
          // Extract leading number from name (e.g., "10-Unit A" → 10)
          const numA = parseInt(a.name.match(/^(\d+)/)?.[0] || '999999');
          const numB = parseInt(b.name.match(/^(\d+)/)?.[0] || '999999');
          
          // If both have numbers, sort numerically
          if (!isNaN(numA) && !isNaN(numB) && numA !== numB) {
            return numA - numB;
          }
          
          // Fallback to alphabetical for names without numbers
          return a.name.localeCompare(b.name);
        };
        
        setTrackers(response.data.sort(naturalSort));
      } else {
        helper.showToast("Error", "Failed to load GPS Trackers", 3);
      }
    });
  }

  const onSave = () => {
    const gpsTracker = trackers[activeIndex];
    customerApi.updateGPSTracker(gpsTracker).then((response) => {
      if (response.status === 200) {
        helper.showToast("Success", "GPS Tracker updated successfully.", 1);
        setIsEdit(false);
        fetchGpsTrackers();
      } else {
        helper.showToast("Error", "Failed to update GPS Tracker.", 3);
      }
    });
  };

  const toggleSelectTracker = (trackerId) => {
    setSelectedTrackerIds((prev) =>
      prev.includes(trackerId)
        ? prev.filter(id => id !== trackerId)
        : [...prev, trackerId]
    );
  };

  const getMapOptions = (maps) => {
    return {
        mapTypeId: maps.MapTypeId.SATELLITE,
        rotateControl: true,
    };
  };
  
  const onEdit = (index) => {
    setActiveIndex(index);
    setIsEdit(true);
  };

  const handleInputChange = (index, field, value) => {
    setTrackers((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  };

  return (
    <>
      <CustomerHeader />
      <Container className="mt--7 mb-8" fluid>
        <Modal isOpen={showMap} toggle={() => setShowMap(false)} modalClassName="map-modal">
          <div style={{ height: '95vh', width: '100%', position: 'relative'  }}>
            <GoogleMapReact
                bootstrapURLKeys={{ key: 'AIzaSyCk2rpWi4waVXWK-zBmstyi7JJOlHinwI8' }}
                yesIWantToUseGoogleMapApiInternals
                defaultCenter={{
                    lat: centerLati,
                    lng: centerLong
                }}
                defaultZoom={16}
                options={getMapOptions}
            >
              {
                trackerPositions.filter(tracker => tracker.latitude).map((tracker) => 
                  <TrackerMarker
                    lat={tracker.latitude}
                    lng={tracker.longitude}
                    tracker={tracker}
                  />
                )
              }
            </GoogleMapReact>
            <Button 
              color="danger" 
              style={{ position: 'absolute', top: 10, right: 10, zIndex: 1000 }}
              onClick={() => setShowMap(false)}
            >
              Close Map
            </Button>
          </div>
        </Modal>
        <Card className="bg-default shadow">
          <CardHeader className="bg-transparent border-0">
            <Row className="align-items-between">
              <div className="col">
                <h2 className="text-white mb-0 text-center">GPS Trackers</h2>
              </div>
              <div>
                <Button color="primary" disabled={selectedTrackerIds.length === 0} onClick={() => setShowMap(true)} className="mr-2 mb-2">
                  View Map
                </Button>
              </div>
            </Row>
          </CardHeader>
          <Table className="align-items-center table-dark table-flush" responsive>
            <thead className="thead-dark">
              <tr>
                <th>
                  <span style={{marginRight: 10}}>
                  Select for Map
                  </span>
                  <input
                      type="checkbox"
                      checked={selectedTrackerIds.length === trackers.length}
                      onChange={(e) => {

                        if(e.target.checked) {
                          setSelectedTrackerIds(trackers.map((t) => t.tracking_id));
                        } else {
                          setSelectedTrackerIds([]);
                        }
                      }}
                    />
                </th>
                <th>Name</th>
                <th>Caddie Name</th>
                <th>Battery Level</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {trackers.map((tracker, index) => (
                isEdit && activeIndex === index ? 
                (
                  <tr key={tracker.id} className={getBatteryTableRowClass(tracker.battery_level)}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedTrackerIds.includes(tracker.tracking_id)}
                        onChange={() => toggleSelectTracker(tracker.tracking_id)}
                      />
                    </td>
                    <td>{tracker.name}</td>
                    <td>
                      <Input value={tracker.caddie_name} onChange={(e) => handleInputChange(index, "caddie_name", e.target.value)} />
                    </td>
                    <td>{formatBatteryLevel(tracker.battery_level)}</td>
                    <td>
                      <Button color="success" onClick={onSave}>Save</Button>
                      <Button color="warning" onClick={() => [setIsEdit(false), fetchGpsTrackers()]}>Cancel</Button>
                    </td>
                  </tr>
                ) : (
                  <tr key={tracker.id} className={getBatteryTableRowClass(tracker.battery_level)}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedTrackerIds.includes(tracker.tracking_id)}
                        onChange={() => toggleSelectTracker(tracker.tracking_id)}
                      />
                    </td>
                    <td>{tracker.name}</td>
                    <td>{tracker.caddie_name}</td>
                    <td>{formatBatteryLevel(tracker.battery_level)}</td>
                    <td>
                      <Button color="info" onClick={() => onEdit(index)}>Edit</Button>
                    </td>
                  </tr>
                )
              ))}
            </tbody>
          </Table>
        </Card>
      </Container>
    </>
  );
}

export default GPSTracker;
